import { brandGraphicMarkup } from "@groundspark/brand";

const brandLockup = brandGraphicMarkup({ symbol: "lockup", tone: "light" });

export function brandLockupContent(): string {
  return brandLockup;
}
